<template>
  <v-container id="task-list">
    <v-row>
      <v-col cols="12" md="12" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="8" offset-sm="4">
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-import-task
              :color="'success'"
              :icon="'mdi-plus-circle'"
              @onSave="$emit('reloadTasks')"
            >
              <template v-slot:title> Importação de Tarefas </template>
            </app-modal-import-task>

            <app-modal-insert-task
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              :filter="filter"
              :municipioSolucaoP="municipioSolucaoP"
              @onSaveTask="$emit('reloadTasks')"
              v-if="
                isFullAdmin ||
                (municipioSolucaoP.municipioSolucao &&
                  municipioSolucaoP.municipioSolucao.municipioSolucaoId)
              "
            >
              <template v-slot:title> Cadastramento Tarefa </template>
            </app-modal-insert-task>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="tasks"
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-insert-task
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  :filter="filter"
                  @onSaveTask="$emit('reloadTasks')"
                >
                  <template v-slot:title> Edição de Tarefa </template>
                </app-modal-insert-task>
              </v-col>

              <v-col cols="1" class="col-min-width-bigger">
                <app-modal-delete-task
                  :payload="item"
                  @on-save="$emit('reloadTasks')"
                >
                  <template v-slot:title> Deletar Tarefa </template>
                </app-modal-delete-task>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <AppRetrieveTask
          :disabledTasks="disabledTasks"
          @onRecover="$emit('reloadTasks')"
        ></AppRetrieveTask>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertTask from "./ModalInsert";
import AppModalDeleteTask from "./ModalDelete";
import { mapGetters } from "vuex";
import AppModalImportTask from "@/modules/task/components/city/ModalImport";
import AppRetrieveTask from "@/modules/task/components/city/RetrieveTask";

export default {
  name: "AppTaskList",
  props: {
    filter: { type: Object, required: true },
    disabledTasks: { type: Array, required: true },
    tasks: { type: Array, required: true },
    municipioSolucaoP: {},
  },
  computed: {
    ...mapGetters(["isFullAdmin"]),
  },
  components: {
    AppModalInsertTask,
    AppModalDeleteTask,
    AppModalImportTask,
    AppRetrieveTask,
  },
  data() {
    return {
      headers: [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Solução",
          value: "municipioSolucao.nome",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ],
      breadcrumbs: [
        {
          text: "Grupos de Soluções",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Soluções",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Tarefas",
          disabled: true,
          href: "termo-referencia",
        },
      ],
      munSolucao: {},
    };
  },
};
</script>

<style lang="scss">
@import "./../style.scss";
</style>
